var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedLabel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.833252,
    y: 0.5,
    width: 14,
    height: 14,
    rx: 2,
    fill: "#F8CECC"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_494_8623)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.427 4.875L8.86073 8.44127C8.73079 8.57121 8.66582 8.63618 8.5909 8.66053C8.525 8.68194 8.45401 8.68194 8.38811 8.66053C8.31319 8.63618 8.24821 8.57121 8.11827 8.44127L6.89198 7.21498C6.76204 7.08504 6.69707 7.02007 6.62215 6.99572C6.55625 6.97431 6.48526 6.97431 6.41936 6.99572C6.34444 7.02007 6.27946 7.08504 6.14952 7.21498L3.2395 10.125M12.427 4.875H9.802M12.427 4.875V7.5",
    stroke: "#E33E3E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_494_8623"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10.5,
    height: 10.5,
    fill: "white",
    transform: "translate(2.58325 2.25)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedLabel);
export default __webpack_public_path__ + "static/media/red_label.18e8160f140ef69947501305d03ae1d1.svg";
export { ForwardRef as ReactComponent };